const hiddenRoutes = [
    {
        path: 'page',
        name: 'page',
        component: () => import('@/layout'),
        redirect: 'noRedirect',
        hidden: true,
        meta: {
            showRealm: ['COMMON'],
            breadcrumb: false,
        },
        children: [
            {
                path: 'goodsConfig',
                name: 'goodsConfig',
                meta: {
                    breadcrumb: false,
                },
                component: () => import('@/views/hiddenPage/goodsConfig'),
            },
            {
                path: 'goodsTranslate',
                name: 'goodsTranslate',
                meta: {
                    breadcrumb: false,
                },
                component: () => import('@/views/hiddenPage/goodsTranslate'),
            },
            {
                path: 'noHeartEsl',
                name: 'noHeartEsl',
                meta: {
                    breadcrumb: false,
                },
                component: () => import('@/views/hiddenPage/noHeartEsl'),
            },
        ]
    }
];
const hiddenWithinGlobal = ['noHeartEsl', 'goodsTranslate', 'goodsConfig'];
export default hiddenRoutes;
export {
    hiddenWithinGlobal
};